// Self-contained Meta Pixel loader.
// We intentionally avoid `react-facebook-pixel` because its script injection
// assumes an existing <script> tag in the document (s.parentNode), which is
// not guaranteed in sandboxed/preview environments and throws.

const PIXEL_ID = '1234041514789512'

let initialized = false

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

function loadFbevents() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq) return

  const fbq: any = function (...args: any[]) {
    fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args)
  }
  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  // Append to <head> which always exists, instead of relying on a sibling
  // <script> tag's parentNode (the cause of the original crash).
  document.head.appendChild(script)
}

export function initPixel() {
  if (initialized || typeof window === 'undefined') return
  try {
    loadFbevents()
    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
    initialized = true
  } catch (err) {
    // Never let analytics break the page.
    console.warn('Meta Pixel init failed:', err)
  }
}

export function trackWhatsAppClick(language: 'es' | 'pap') {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    // Standard "Contact" event so it appears in Meta's Events Manager.
    window.fbq('track', 'Contact', {
      content_name: 'WhatsApp',
      language,
    })
    // Custom event for per-button granularity.
    window.fbq('trackCustom', 'WhatsAppClick', { language })
  } catch (err) {
    console.warn('Meta Pixel track failed:', err)
  }
}
